(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video-poster-fix"] && !Shopify.designMode) return;
  try {
    (function () {
    var CLASS = 'sap-poster-fix';
    var PLAYING = 'sap-poster-fix--playing';

    function markPlaying(video) {
      if (video && video.classList && video.classList.contains(CLASS)) {
        video.classList.add(PLAYING);
      }
    }

    // Media events do not bubble; a capture-phase listener on the document still
    // receives them, and survives Section Rendering API swaps of the video markup.
    document.addEventListener('playing', function (event) { markPlaying(event.target); }, true);

    // Videos that started before this script attached.
    document.querySelectorAll('video.' + CLASS).forEach(function (video) {
      if (!video.paused && video.currentTime > 0) markPlaying(video);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
